import { DatePipe } from '@angular/common';
import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Tabs } from 'primeng/tabs';
import { forkJoin } from 'rxjs';
import { ApiResponse } from '../../../../models/api-response.model';
import { Milestone2Designation } from '../../../../models/milestone2-designation.model';
import { Milestone2PaymentStatus } from '../../../../models/milestone2-payment-status.model';
import { MsaipMilestonePayment } from '../../../../models/msai-m2-payment-details.model';
import { CommonService } from '../../../common/common.service';
import { CommonSharedModule } from '../../../common/shared.module';
import { OsmosisEditService } from '../../../services/osmosis-edit.service';

@Component({
  selector: 'app-incentive-payment-milestone-two',
  templateUrl: './incentive-payment-milestonetwo.component.html',
  styleUrls: ['./incentive-payment-milestonetwo.component.scss'],
  standalone: true,
  imports: [CommonSharedModule]
})
export class IncentivePaymentMilestoneTwoComponent implements OnInit {
  @Input() incentiveId!: number;
  @ViewChild(Tabs, { static: false }) tabView!: Tabs;
  @Input() programTypeId!: number;
  formFrontlineWorker!: FormGroup;
  formMicrosoftViva!: FormGroup;
  datePipe = new DatePipe('en-US');
  maxYearDate!: Date;

  msgsMilestone2InvoiceDetails!: any[];
  paymentMilestone2btnNav = false;
  isReadonlyMilestone2Payment = true;
  isReadonlyMilestone2Details = true;
  hasMilestone2Data = false;
  paymentStatus!: Milestone2PaymentStatus[];
  milestone2Designations!: Milestone2Designation[];
  milestone2Details!: MsaipMilestonePayment[];
  apires!: ApiResponse;
  milestonePayment!: MsaipMilestonePayment;
  @Input() isOptOutPartner = true;

  constructor(
    private formBuilder: FormBuilder,
    private commonService: CommonService,
    private osmEdit: OsmosisEditService
  ) {}

  ngOnInit() {
    this.onFormGroup();
  }
  onFormGroup() {
    this.maxYearDate = new Date(
      new Date().setFullYear(new Date().getFullYear())
    );
    this.formFrontlineWorker = this.formBuilder.group({
      milestone2Designation: [''],
      payoutMetric: [''],
      tier1PaymentAmount: [''],
      tier1MetDate: [''],
      tier2PaymentAmount: [''],
      tier2MetDate: [''],
      tier3PaymentAmount: [''],
      tier3MetDate: [''],
      tier1PaidDate: [''],
      tier2PaidDate: [''],
      tier3PaidDate: [''],
      tier1InvoiceNumber: [''],
      tier2InvoiceNumber: [''],
      tier3InvoiceNumber: [''],
      tier1PaymentStatus: [''],
      tier2PaymentStatus: [''],
      tier3PaymentStatus: [''],
      tier1PaymentCentralTransactionId: [''],
      tier2PaymentCentralTransactionId: [''],
      tier3PaymentCentralTransactionId: [''],
      tier1PaymentDocumentId: [''],
      tier2PaymentDocumentId: [''],
      tier3PaymentDocumentId: [''],
      engagementSubID: ['']
    });
    this.getDesignationsAndPaymentStatus();
  }
  getM2PaymentIncentive() {
    this.osmEdit
      .getIncentivePaymentM2DetailsById(this.incentiveId)
      .subscribe(milestonePayments => {
        if (!milestonePayments) {
          return;
        }
        if (milestonePayments.length > 0) {
          this.hasMilestone2Data = true;
        }
        milestonePayments.forEach(milestonePayment => {
          if (
            milestonePayment.payoutMetric == 'M365 Security Sales' ||
            milestonePayment.payoutMetric == 'Billed Revenue'
          ) {
            this.formFrontlineWorker = this.buildPaymentForm(milestonePayment);
          }
        });
      });
  }

  getDesignationsAndPaymentStatus() {
    const getPaymentStatus = this.osmEdit.getMilestone2PaymentStatusDropdown();
    const getDesignations = this.osmEdit.getMilestone2DesignationDropdown();
    const getMilestone2Details = this.osmEdit.getIncentivePaymentM2DetailsById(
      this.incentiveId
    );

    forkJoin([
      getPaymentStatus,
      getDesignations,
      getMilestone2Details
    ]).subscribe(results => {
      this.paymentStatus = results[0];
      this.milestone2Designations = results[1];
      this.milestone2Details = results[2];
      this.getM2PaymentIncentive();
    });
  }

  getPaymentStatusName(paymentStatusId: number) {
    return this.paymentStatus.find(p => p.paymentStatusId === paymentStatusId)
      ?.paymentStatusName;
  }

  editMilestone2Payment() {
    this.isReadonlyMilestone2Payment = false;
    this.paymentMilestone2btnNav = true;
    this.msgsMilestone2InvoiceDetails = [];
  }

  editMilestone2PaymentCancel(formMilestone2Payment: FormGroup) {
    this.isReadonlyMilestone2Payment = true;
    this.paymentMilestone2btnNav = false;
    this.msgsMilestone2InvoiceDetails = [];
    this.clearFormValues(formMilestone2Payment);
    this.getM2PaymentIncentive();
  }

  clearFormValues(formMilestone2Payment: FormGroup) {
    formMilestone2Payment.patchValue({
      milestone2Designation: '',
      tier1InvoiceNumber: '',
      tier2InvoiceNumber: '',
      tier3InvoiceNumber: '',
      tier1PaidDate: '',
      tier2PaidDate: '',
      tier3PaidDate: '',
      tier1PaymentCentralTransactionId: '',
      tier2PaymentCentralTransactionId: '',
      tier3PaymentCentralTransactionId: '',
      tier1PaymentStatus: '',
      tier2PaymentStatus: '',
      tier3PaymentStatus: '',
      tier1PaymentDocumentId: '',
      tier2PaymentDocumentId: '',
      tier3PaymentDocumentId: ''
    });
  }

  buildPaymentForm(milestonePayment: MsaipMilestonePayment) {
    const tier1MetFormattedDate =
      milestonePayment.tier1MetDate == 'NULL'
        ? ''
        : this.datePipe.transform(milestonePayment.tier1MetDate, 'MM/dd/yyyy');
    const tier2MetFormattedDate =
      milestonePayment.tier2MetDate == 'NULL'
        ? ''
        : this.datePipe.transform(milestonePayment.tier2MetDate, 'MM/dd/yyyy');
    const tier3MetFormattedDate =
      milestonePayment.tier3MetDate == 'NULL'
        ? ''
        : this.datePipe.transform(milestonePayment.tier3MetDate, 'MM/dd/yyyy');

    const tier1PaidFormattedDate = this.datePipe.transform(
      milestonePayment.tier1PaidDate,
      'MM/dd/yyyy'
    );
    const tier2PaidFormattedDate = this.datePipe.transform(
      milestonePayment.tier2PaidDate,
      'MM/dd/yyyy'
    );
    const tier3PaidFormattedDate = this.datePipe.transform(
      milestonePayment.tier3PaidDate,
      'MM/dd/yyyy'
    );
    return this.formBuilder.group({
      payoutMetric: milestonePayment.payoutMetric,
      tier1PaymentAmount: milestonePayment.tier1PaymentAmount,
      tier2PaymentAmount: milestonePayment.tier2PaymentAmount,
      tier3PaymentAmount: milestonePayment.tier3PaymentAmount,
      tier1MetDate: tier1MetFormattedDate,
      tier2MetDate: tier2MetFormattedDate,
      tier3MetDate: tier3MetFormattedDate,
      tier1PaidDate: tier1PaidFormattedDate,
      tier2PaidDate: tier2PaidFormattedDate,
      tier3PaidDate: tier3PaidFormattedDate,
      tier1InvoiceNumber: milestonePayment.tier1InvoiceNumber,
      tier2InvoiceNumber: milestonePayment.tier2InvoiceNumber,
      tier3InvoiceNumber: milestonePayment.tier3InvoiceNumber,
      tier1PaymentCentralTransactionId:
        milestonePayment.tier1PaymentCentralTransactionId,
      tier2PaymentCentralTransactionId:
        milestonePayment.tier2PaymentCentralTransactionId,
      tier3PaymentCentralTransactionId:
        milestonePayment.tier3PaymentCentralTransactionId,
      tier1PaymentStatus: {
        paymentStatusId: milestonePayment.tier1PaymentStatus,
        paymentStatusName:
          milestonePayment.tier1PaymentStatus == null
            ? null
            : this.getPaymentStatusName(milestonePayment.tier1PaymentStatus)
      },
      tier2PaymentStatus: {
        paymentStatusId: milestonePayment.tier2PaymentStatus,
        paymentStatusName:
          milestonePayment.tier2PaymentStatus == null
            ? null
            : this.getPaymentStatusName(milestonePayment.tier2PaymentStatus)
      },
      tier3PaymentStatus: {
        paymentStatusId: milestonePayment.tier3PaymentStatus,
        paymentStatusName:
          milestonePayment.tier3PaymentStatus == null
            ? null
            : this.getPaymentStatusName(milestonePayment.tier3PaymentStatus)
      },
      tier1PaymentDocumentId: milestonePayment.tier1PaymentDocumentNumber,
      tier2PaymentDocumentId: milestonePayment.tier2PaymentDocumentNumber,
      tier3PaymentDocumentId: milestonePayment.tier3PaymentDocumentNumber,
      engagementSubID: milestonePayment.engagementSubID
    });
  }

  onSubmitMilestone2PaymentInvoice(formMilestone2Payment: FormGroup) {
    this.milestonePayment = {
      engagementId: this.incentiveId.toString(),
      engagementSubID: formMilestone2Payment.controls['engagementSubID'].value,
      payoutMetric: formMilestone2Payment.controls['payoutMetric'].value,
      tier1InvoiceNumber:
        formMilestone2Payment.controls['tier1InvoiceNumber'].value,
      tier1PaidDate: formMilestone2Payment.controls['tier1PaidDate'].value,
      tier1PaymentCentralTransactionId:
        formMilestone2Payment.controls['tier1PaymentCentralTransactionId']
          .value,
      tier1PaymentStatus:
        formMilestone2Payment.controls['tier1PaymentStatus'].value === null
          ? null
          : formMilestone2Payment.controls['tier1PaymentStatus'].value
              .paymentStatusId,
      tier1PaymentDocumentNumber:
        formMilestone2Payment.controls['tier1PaymentDocumentId'].value,
      tier2InvoiceNumber:
        formMilestone2Payment.controls['tier2InvoiceNumber'].value,
      tier2PaidDate: formMilestone2Payment.controls['tier2PaidDate'].value,
      tier2PaymentCentralTransactionId:
        formMilestone2Payment.controls['tier2PaymentCentralTransactionId']
          .value,
      tier2PaymentStatus:
        formMilestone2Payment.controls['tier2PaymentStatus'].value === null
          ? null
          : formMilestone2Payment.controls['tier2PaymentStatus'].value
              .paymentStatusId,
      tier2PaymentDocumentNumber:
        formMilestone2Payment.controls['tier2PaymentDocumentId'].value,
      tier3InvoiceNumber:
        formMilestone2Payment.controls['tier3InvoiceNumber'].value,
      tier3PaidDate: formMilestone2Payment.controls['tier3PaidDate'].value,
      tier3PaymentCentralTransactionId:
        formMilestone2Payment.controls['tier3PaymentCentralTransactionId']
          .value,
      tier3PaymentStatus:
        formMilestone2Payment.controls['tier3PaymentStatus'].value === null
          ? null
          : formMilestone2Payment.controls['tier3PaymentStatus'].value
              .paymentStatusId,
      tier3PaymentDocumentNumber:
        formMilestone2Payment.controls['tier3PaymentDocumentId'].value
    } as any;

    this.osmEdit.updateMsaipM2InvoiceDetails(this.milestonePayment).subscribe(
      messageResponse => {
        this.apires = messageResponse;
        if (this.apires.success === true) {
          this.msgsMilestone2InvoiceDetails = [];
          this.msgsMilestone2InvoiceDetails.push({
            severity: 'success',
            detail: 'Milestone 2 Invoice Details Saved Successfully.'
          });
          this.isReadonlyMilestone2Payment = true;
          this.paymentMilestone2btnNav = false;
        }
        if (this.apires.success === false) {
          this.msgsMilestone2InvoiceDetails = [];
          this.msgsMilestone2InvoiceDetails.push({
            severity: 'error',
            detail: this.apires.errorMessages
              ? this.apires.errorMessages[0]
              : 'Unknown error'
          });
        }
      },
      error => {
        this.msgsMilestone2InvoiceDetails = [];
        let errors: string[] = [];
        if (error.status === 400) {
          errors = this.commonService.getBadRequestErrors(error);
          for (const msg of errors) {
            this.msgsMilestone2InvoiceDetails.push({
              severity: 'warn',
              detail: msg
            });
          }
        } else {
          this.msgsMilestone2InvoiceDetails.push({
            severity: 'warn',
            detail:
              'Sorry an error occured while updating milestone 2 invoice details'
          });
        }
      }
    );
  }
}
